/**
 * Smooth Sticky Header with Blue Background
 * Professional smooth animations for desktop and mobile
 */

(function() {
  'use strict';
  
  // Configuration
  const config = {
    stickyClass: 'is-sticky',
    stickyBlueClass: 'sticky-blue-header',
    scrollThreshold: 200,
    transitionDuration: 400, // milliseconds
    headerSelector: '.header-area',
    mobileBreakpoint: 991
  };
  
  let lastScrollTop = 0;
  let isSticky = false;
  let ticking = false;
  
  // Get header element
  const header = document.querySelector(config.headerSelector);
  
  if (!header) {
    console.warn('Header element not found');
    return;
  }
  
  // Add smooth transition styles
  const style = document.createElement('style');
  style.textContent = `
    /* Smooth Sticky Header Styles */
    ${config.headerSelector} {
      transition: all ${config.transitionDuration}ms cubic-bezier(0.4, 0, 0.2, 1);
      will-change: transform, background-color, box-shadow;
    }
    
    ${config.headerSelector}.${config.stickyClass} {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 9999;
      animation: slideDown ${config.transitionDuration}ms cubic-bezier(0.4, 0, 0.2, 1);
    }
    
    /* Blue background when sticky */
    ${config.headerSelector}.${config.stickyBlueClass} {
      background: linear-gradient(135deg, #0b3350 0%, #154a6e 100%) !important;
      box-shadow: 0 4px 20px rgba(11, 51, 80, 0.25);
    }
    
    ${config.headerSelector}.${config.stickyBlueClass} .main-menu > nav > ul > li > a,
    ${config.headerSelector}.${config.stickyBlueClass} .header-right-wrap .header-search > a,
    ${config.headerSelector}.${config.stickyBlueClass} .cart-wrap > button span.icon-cart,
    ${config.headerSelector}.${config.stickyBlueClass} .cart-wrap > button span.cart-price,
    ${config.headerSelector}.${config.stickyBlueClass} .header-right-wrap .setting-wrap button {
      color: #ffffff !important;
      transition: color 0.3s ease;
    }
    
    ${config.headerSelector}.${config.stickyBlueClass} .main-menu > nav > ul > li > a:hover,
    ${config.headerSelector}.${config.stickyBlueClass} .header-right-wrap .header-search > a:hover,
    ${config.headerSelector}.${config.stickyBlueClass} .cart-wrap > button:hover span.icon-cart,
    ${config.headerSelector}.${config.stickyBlueClass} .header-right-wrap .setting-wrap button:hover {
      color: #fca148 !important;
    }
    
    ${config.headerSelector}.${config.stickyBlueClass} .header-right-wrap .setting-wrap button svg,
    ${config.headerSelector}.${config.stickyBlueClass} .cart-wrap>button span.icon-cart svg,
    ${config.headerSelector}.${config.stickyBlueClass} .header-right-wrap .header-search svg {
      fill: #ffffff !important;
      transition: fill 0.3s ease;
    }
    
    ${config.headerSelector}.${config.stickyBlueClass} .header-right-wrap .setting-wrap button:hover svg,
    ${config.headerSelector}.${config.stickyBlueClass} .cart-wrap>button:hover span.icon-cart svg,
    ${config.headerSelector}.${config.stickyBlueClass} .header-right-wrap .header-search:hover svg {
      fill: #fca148 !important;
    }
    
    /* Slide down animation */
    @keyframes slideDown {
      from {
        transform: translateY(-100%);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
    
    /* Mobile specific styles */
    @media only screen and (max-width: ${config.mobileBreakpoint}px) {
      ${config.headerSelector}.${config.stickyClass} {
        padding-top: 8px;
        padding-bottom: 8px;
      }
      
      ${config.headerSelector}.${config.stickyBlueClass} .header-logo img {
        max-height: 40px;
        transition: max-height 0.3s ease;
      }
    }
    
    /* Desktop specific styles */
    @media only screen and (min-width: ${config.mobileBreakpoint + 1}px) {
      ${config.headerSelector}.${config.stickyClass} {
        padding-top: 5px;
        padding-bottom: 5px;
      }
      
      ${config.headerSelector}.${config.stickyBlueClass} .theme-logo img {
        max-height: 50px;
        transition: max-height 0.3s ease;
      }
    }
    
    /* Prevent jerky animations */
    html.smooth-scroll {
      scroll-behavior: smooth;
    }
  `;
  document.head.appendChild(style);
  
  /**
   * Handle scroll event
   */
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > config.scrollThreshold) {
      if (!isSticky) {
        makeSticky();
      }
    } else {
      if (isSticky) {
        removeSticky();
      }
    }
    
    lastScrollTop = scrollTop;
  }
  
  /**
   * Make header sticky with smooth transition
   */
  function makeSticky() {
    isSticky = true;
    
    // Add placeholder to prevent content jump
    if (!header.nextElementSibling || !header.nextElementSibling.classList.contains('header-placeholder')) {
      const placeholder = document.createElement('div');
      placeholder.className = 'header-placeholder';
      placeholder.style.height = header.offsetHeight + 'px';
      placeholder.style.transition = `height ${config.transitionDuration}ms ease`;
      header.parentNode.insertBefore(placeholder, header.nextSibling);
    }
    
    // Add sticky classes with slight delay for smooth animation
    requestAnimationFrame(() => {
      header.classList.add(config.stickyClass);
      
      // Add blue background class after sticky is applied
      setTimeout(() => {
        header.classList.add(config.stickyBlueClass);
      }, 50);
    });
  }
  
  /**
   * Remove sticky state
   */
  function removeSticky() {
    isSticky = false;
    
    // Remove sticky classes
    header.classList.remove(config.stickyClass, config.stickyBlueClass);
    
    // Remove placeholder
    const placeholder = document.querySelector('.header-placeholder');
    if (placeholder) {
      setTimeout(() => {
        placeholder.remove();
      }, config.transitionDuration);
    }
  }
  
  /**
   * Optimized scroll handler using requestAnimationFrame
   */
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  /**
   * Initialize
   */
  function init() {
    // Check initial scroll position
    handleScroll();
    
    // Add scroll listener
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (isSticky) {
          const placeholder = document.querySelector('.header-placeholder');
          if (placeholder) {
            placeholder.style.height = header.offsetHeight + 'px';
          }
        }
      }, 250);
    }, { passive: true });
    
    console.log('Smooth sticky header initialized');
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Expose config for external modification if needed
  window.stickyHeaderConfig = config;
  
})();